import { ReportSubtypeEnum } from "Common/enum";

export const ReportSubtypeEnumLabels: { [key in number]: string } = {
  [ReportSubtypeEnum.Regular]: "Regular",
  [ReportSubtypeEnum.Summary]: "Summary",
  [ReportSubtypeEnum.MasterDetails]: "Master details",
};